import React, { useLayoutEffect } from 'react';
import type { JSX } from 'react';
import { Navigate } from 'react-router';
import { miscToasts } from '../../toasts/toasts';
import { UIActions } from '../../ui/uiSlice';
import useAppSelector, { useAppDispatch } from '../redux/useAppSelector';
import EnsureUser from './EnsureUser';

interface EnsureAdminProps {
  children: JSX.Element;
}

const EnsureAdmin = ({ children }: EnsureAdminProps) => {
  const { id, type } = useAppSelector((state) => state.session.user);
  const dispatch = useAppDispatch();

  useLayoutEffect(() => {
    if (id && type !== 'ADMIN') {
      dispatch(UIActions.pushToast(miscToasts.mustBeAdminWarning));
    }
  }, [dispatch, id, type]);

  if (!id) return <EnsureUser />;

  if (type !== 'ADMIN') {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default EnsureAdmin;
